import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { tap } from 'rxjs';
import { OrderStatistic } from '../../models/order-statistics';

@Injectable({
  providedIn: 'root'
})
export class OrderStatisticsService {
  constructor(protected http: HttpClient) {}

  getOrderStatistics(date): Observable<any> {
    return this.http.get<any>('json/order-statistics-nostream?minDate=' + date);
  }
}
